// src/components/projects/ProjectTaskList.jsx - Simplified to use unified components
import React from 'react';
import { useOutletContext } from 'react-router-dom';

// Unified task components
import UnifiedTaskList from '../tasks/UnifiedTaskList';

/**
 * ProjectTaskList component - Clean List view using unified system
 */
const ProjectTaskList = ({ projectId: propProjectId }) => {
  // Get project context if available
  const context = useOutletContext?.() || {};
  const { project } = context;
  
  // Use projectId from props or context
  const projectId = propProjectId || project?._id;
  
  // Get team members from project
  const teamMembers = project?.team?.map(member => member.user) || [];
  
  // Return the unified task list
  return (
    <UnifiedTaskList
      projectId={projectId}
      teamMembers={teamMembers}
      showProject={false}
      groupBySections={true}
    />
  );
};

export default ProjectTaskList;